module.exports = __webpack_public_path__ + "static/media/ceiling-front.fb50cc4b.png";